import React, { useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Form, Button, Modal } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { createPayment, createPaymentAndSignUp } from "actions/payment";
import { showError } from "actions/utils";
import { useHistory } from "react-router";
import { STATUS } from "api/status";
import CardHeader from "./CardHeader";

export const CardForm = ({ onCancel, userInfo, message, title }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsClicked(true)
    const { token } = await stripe.createToken(elements.getElement(CardElement));
    if (token) {
      setLoading(true);
      const response = history.location.pathname === '/renew' ? await dispatch(createPayment({ ...userInfo, stripeToken: token?.id })) : await dispatch(createPaymentAndSignUp({ ...userInfo, stripeToken: token?.id }));
      setLoading(false);
      onCancel();

      if(response === STATUS.success) {
        history.push(history.location.pathname === '/renew' ? '/details' : '/login');
      }
    } else {
      setIsClicked(false);
      showError({ text: "Complete form with correct values" });
    }
  };

  return (
    <>
      <Modal
        size="tiny"
        onClose={onCancel}
        open
        closeOnDimmerClick={false}
        closeIcon={false}
      >
        <Modal.Header content={<CardHeader message={message} title={title} />}/>
        <Modal.Content as={Form}>
          <CardElement />
        </Modal.Content>
        <Modal.Actions>
          <Button secondary content="Cancel" onClick={onCancel} />
          <Button
            onClick={handleSubmit}
            primary
            loading={loading}
            icon="right chevron"
            labelPosition="right"
            content={history.location.pathname === "/renew" ? "Renew subscription" : "Register!"}
            disabled={!stripe || loading || isClicked}
          />
        </Modal.Actions>
      </Modal>
    </>
  );
};
